import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { FilterModalActivities } from './filterModalActivities.component';
import { FiltersActions, selectCurrentFilter, selectFirstSelectedMarketId } from '../../../../modules/filters';
import { selectMarketsCategories } from '../../../../modules/market';

const mapStateToProps = createStructuredSelector({
  selectedMarketId: selectFirstSelectedMarketId,
  categoriesData: selectMarketsCategories,
  currentFilter: selectCurrentFilter,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setFilterDataByFilterName: FiltersActions.setFilterDataByFilterName,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(FilterModalActivities);
